import React from "react";
import Image from "next/image";
import Marquee from "react-fast-marquee";
import { FaArrowRight } from "react-icons/fa";
import { useRouter } from "next/router";
import CaseStudyHoverCard from "./CaseStudyHoverCard";
import { caseStudies } from "./case-studies-constants";
import { BASE_ASSETS_URL } from "@constants/constants";

export const companyLogos = [
  {
    url: "9.png",
    name: "ABC Eyecare",
    haveCaseStudy: true,
    companyKey: "abc-eyecare".toLowerCase(),
  },
  {
    url: `5.png`,
    name: "Angelfire",
    haveCaseStudy: true,
    companyKey: "angel-fire".toLowerCase(),
  },
  {
    url: `10.png`,
    name: "G & H Transport",
    haveCaseStudy: true,
    companyKey: "g-h-transport".toLowerCase(),
  },

  {
    url: `4.png`,
    name: "Beaver",
    haveCaseStudy: true,
    companyKey: "beaver".toLowerCase(),
  },
  {
    url: `2.png`,
    name: "Shine Above",
    haveCaseStudy: true,
    companyKey: "shine-above".toLowerCase(),
  },
  {
    url: `1.png`,
    name: "Harry Corry",
    haveCaseStudy: true,
    companyKey: "harry-corry-ltd".toLowerCase(),
  },
  {
    url: `6.png`,
    name: "Rethink",
    haveCaseStudy: true,
    companyKey: "rethink".toLowerCase(),
  },

  {
    url: "12.png",
    name: "Overstock Furniture",
    haveCaseStudy: true,
    companyKey: "overstock-furniture".toLowerCase(),
  },
  {
    url: "11.png",
    name: "Lifestyle Design",
    haveCaseStudy: true,
    companyKey: "lifestyle-design".toLowerCase(),
  },
  {
    url: `7.png`,
    name: "Mancosa",
    haveCaseStudy: true,
    companyKey: "mancosa".toLowerCase(),
  },
  {
    url: `3.png`,
    name: "Aging Comfort",
    haveCaseStudy: true,
    companyKey: "aging-comfort".toLowerCase(),
  },
  {
    url: `8.png`,
    name: "Benavest",
    haveCaseStudy: true,
    companyKey: "benavest".toLowerCase(),
  },
];
const generateTestimonials = (companyKey) => {
  let caseStudy = caseStudies.find((caseStudy) => caseStudy.key === companyKey);
  if (!caseStudy) {
    caseStudy = caseStudies.find(
      (caseStudy) => caseStudy.key === "harry-corry-ltd"
    );
  }
  const testimonial = {
    logo: caseStudy.companyLogo,
    company: caseStudy.name,
    quote: caseStudy.customerInsight.insight,
    name: caseStudy.customerInsight.by,
    title: caseStudy.customerInsight.authorPosition,
    avatar: caseStudy.customerInsight.image,
  };
  return testimonial;
};

const AnimatedLogos = ({ isInvert = false }) => {
  const router = useRouter();
  const [hoveredIdx, setHoveredIdx] = React.useState(null);
  const [hoveredKey, setHoveredKey] = React.useState(null);
  const [hoverPosition, setHoverPosition] = React.useState({ x: 0, y: 0 });

  const handleLogoClick = (companyKey) => {
    router.push(`/signature/case-studies/${companyKey}`);
  };

  const handleMouseEnter = ({ idx, companyKey, event }) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const marqueeRect = event.currentTarget
      .closest(".marquee-container")
      .getBoundingClientRect();

    // Calculate position relative to the marquee container
    const x = rect.left - marqueeRect.left + rect.width / 2;
    const y = rect.top - marqueeRect.top;

    let formattedY = y - 280;
    if (companyKey === "angelfire") {
      formattedY = y - 320;
    } else if (companyKey === "mancosa") {
      formattedY = y - 380;
    } else if (companyKey === "beaver") {
      formattedY = y - 320;
    }

    setHoverPosition({ x, y: formattedY });
    setHoveredIdx(idx);
  };

  return (
    <div className="w-full overflow-visible relative h-fit ">
      <div className="marquee-container relative overflow-hidden">
        <Marquee
          gradient={false}
          speed={40}
          className=" overflow-hidden p-2 rounded-md"
          pauseOnHover={true}
        >
          {companyLogos.map((logo, idx) => (
            <div
              key={idx}
              className="mx-8 flex flex-col items-center group cursor-pointer relative h-[144px]"
              onClick={() => handleLogoClick(logo.companyKey)}
              onMouseEnter={(e) =>
                handleMouseEnter({ idx, companyKey: logo.companyKey, event: e })
              }
              onMouseLeave={() => setHoveredIdx(null)}
            >
              <div className="relative h-full">
                <Image
                  src={`${BASE_ASSETS_URL}/v2/clm/company/${logo.url}`}
                  alt={logo.name}
                  className={`object-contain transition duration-300 group-hover:filter ${
                    isInvert ? "invert" : ""
                  }`}
                  width={120}
                  height={120}
                  loading="lazy"
                />
                {/* {logo.haveCaseStudy && (
                  <div className="absolute bottom-[-10px] right-0 w-[120px] flex items-center justify-center z-10 h-8 ">
                    <button className="bg-white text-dark text-[10px] h-6 rounded-full flex items-center gap-1    border-[0.5px] border-blue-50 w-[100px] justify-center ">
                      <span>Case study</span>
                      <FaArrowRight className="text-[8px] text-dark group-hover:ml-2 ml-0 transition-all duration-300" />
                    </button>
                  </div>
                )} */}
              </div>
            </div>
          ))}
        </Marquee>
      </div>
      {/* Hover Card - Positioned based on hovered logo */}
      {/* {hoveredIdx !== null && (
        <div
          className="absolute z-[1000]"
          style={{
            left: `${hoverPosition.x}px`,
            top: `${hoverPosition.y}px`,
            transform: "translateX(-50%)",
          }}
        >
          <CaseStudyHoverCard
            {...generateTestimonials(companyLogos[hoveredIdx].companyKey)}
          />
        </div>
      )} */}
    </div>
  );
};

export default AnimatedLogos;
